import React, { useContext } from 'react';
import { useOpenBriefCreationDrawer } from '@fiverr-private/dm_brief_creation_triggers';
import { useBusinessSignInSteps } from '@fiverr-private/identification_triggers';
import { BUSINESS_TRIGGER_CTA } from '@fiverr-private/business_success_sign_modal';
import { Alert, AlertTitle, AlertText, AlertActions, AlertActionButton } from '@fiverr-private/feedback';
import { I18n } from '@fiverr-private/i18n-react';
import { DEFAULT_CURRENCY } from '@fiverr-private/listing_lib';
import { AppContext } from '../../../context/listingsContext';
import { getBqEventSource } from '../../biUtils';
import { useBusinessListingsContext } from '../../BusinessPageLayout';
import { T_PREFIX } from '../../BusinessPageLayout/ItemsContainer/NoResults/utils';
import { trackingPageName } from '../../../../../../shared/services/BIEvents/utils';

export const TopPlaceholderBanner: React.FC = () => {
    const { resultsCount, isExpertListings } = useBusinessListingsContext();
    const { flow, currency } = useContext(AppContext);

    const pageName = trackingPageName(isExpertListings, flow);
    const source = getBqEventSource(isExpertListings);
    const { openBriefCreationDrawer } = useOpenBriefCreationDrawer();

    const { signInSteps: onPostBriefClick } = useBusinessSignInSteps({
        id: `${pageName}-${source}:top_placeholder_banner_brief`,
        onSuccess: () =>
            openBriefCreationDrawer({
                currency: currency || DEFAULT_CURRENCY,
                source: `${source}${resultsCount > 0 ? '' : '_no_results'}`,
            }),
        signInModalParams: {
            source,
            businessTriggerCtaType: BUSINESS_TRIGGER_CTA.NO_RESULT_PAGE_BRIEF,
            biEnrichmentParams: { source },
        },
        activationModalParams: {},
        migrateModalParams: {
            source,
            biEnrichment: {
                pageElementName: source,
                trigger: BUSINESS_TRIGGER_CTA.NO_RESULT_PAGE_BRIEF,
            },
        },
    });

    return (
        <div style={{ marginBottom: 16 }}>
            <Alert variant="warning" showIcon={false} dataTrackValue="top_placeholder_banner">
                <AlertTitle>
                    <I18n k={`${T_PREFIX}.banners.top_placeholder.title`} />
                </AlertTitle>

                <AlertText>
                    <I18n k={`${T_PREFIX}.banners.top_placeholder.description`} />
                </AlertText>

                <AlertActions>
                    <AlertActionButton
                        intent="primary"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onPostBriefClick();
                        }}
                        dataTrackValue="post_brief_cta"
                    >
                        <I18n k={`${T_PREFIX}.no_results.buttons.fill_out_brief_cta`} />
                    </AlertActionButton>
                </AlertActions>
            </Alert>
        </div>
    );
};
